<template>
    <div class="relative">
        <div @click="hasContent ? open = ! open : null">
            <slot name="trigger"></slot>
        </div>

        <div v-show="open" class="fixed inset-0" @click="open = false">
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div v-show="open"
                 class="origin-top-right absolute right-0 mt-2 rounded-md shadow-lg z-10"
                 :class="[width, alignmentClasses]"
                 style="display: none;"
                 @click="open = false">
                <div class="py-1 rounded-md bg-white shadow-xs" :class="contentClasses" role="menu"
                     aria-orientation="vertical"
                     aria-labelledby="user-menu">
                    <slot name="content"></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'BaseDropdown',

    props: {
        align: {
            default: 'right',
        },
        width: {
            default: 'w-auto',
        },
        contentClasses: {
            default: () => ['py-1', 'bg-white'],
        },
    },

    data() {
        return {
            open: false,
        };
    },

    computed: {
        hasContent() {
            return !!this.$slots.content;
        },
        alignmentClasses() {
            if (this.align === 'left') {
                return 'origin-top-left left-0';
            } else if (this.align === 'right') {
                return 'origin-top-right right-0';
            } else {
                return 'origin-top';
            }
        },
    },

    created() {
        const closeOnEscape = (e) => {
            if (this.open && e.keyCode === 27) {
                this.open = false;
            }
        };

        this.$once('hook:destroyed', () => {
            document.removeEventListener('keydown', closeOnEscape);
        });

        document.addEventListener('keydown', closeOnEscape);
    },
};
</script>
